import { render, staticRenderFns } from "./FoodGroupTableRow.vue?vue&type=template&id=3c6e2ebb&"
import script from "./FoodGroupTableRow.vue?vue&type=script&lang=js&"
export * from "./FoodGroupTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports